module.exports = __webpack_public_path__ + "static/media/bunny.90a223d6.jpg";